import React from 'react';
import { Select } from 'antd';
import style from './style.module.scss';
import { BACKGROUND_COLORS } from './constants';
import { localizeLanguage } from '../../utils/languages';
import { LabeledField } from '../form-fields/labeled-field';

const { Option } = Select;

interface BackgroundColorPickerProps {
    value?: string | null;
    onChange: (value: string | null) => void;
    language?: 'en' | 'fr';
    className?: string;
}

export const BackgroundColorPicker: React.FC<BackgroundColorPickerProps> = ({
    value,
    onChange,
    language = 'en',
    className = '',
}) => {
    const languageLabel = localizeLanguage(language);
    return (
        <LabeledField label={`Background (${languageLabel})`}>
            <Select
                value={value ?? undefined}
                onChange={onChange}
                placeholder="Select a color"
                allowClear
                className={`${style.select} ${className}`}
                popupClassName={style.dropdown}
            >
                {BACKGROUND_COLORS.map((color) => (
                    <Option key={color.value} value={color.value}>
                        <div className={style.option_content}>
                            <div
                                className={style.color_box}
                                style={{
                                    backgroundColor: color.backgroundColor,
                                }}
                            />
                            <span className={style.color_label}>
                                {color.label}
                            </span>
                        </div>
                    </Option>
                ))}
            </Select>
        </LabeledField>
    );
};
